import { render, staticRenderFns } from "./procedure-menu.vue?vue&type=template&id=9592c224&%40click%3Aoutside=closeThisMenu&"
import script from "./procedure-menu.vue?vue&type=script&lang=js&"
export * from "./procedure-menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports